(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-store/assets/javascripts/utils/last-searched.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-store/assets/javascripts/utils/last-searched.js');
"use strict";


const {
  store
} = svs.components.casino_react.casinoStore;
const {
  addGameToLastSearched,
  clearLastSearched
} = svs.components.casino_react.casinoStore.actions.lastSearched;
const dispatchGameToLastSearched = systemName => {
  store.dispatch(addGameToLastSearched(systemName));
};
const dispatchClearLastSearched = () => {
  store.dispatch(clearLastSearched());
};
setGlobal('svs.components.casino_react.casinoStore.utils.lastSearched', {
  dispatchGameToLastSearched,
  dispatchClearLastSearched
});

 })(window);